import axios from 'axios';


export const getWeatherForecast = (lat,lon)=> async(dispatch) =>{

    try {
         
        const{data} = await axios.get(`https://api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${lon}&units=metric&appid=${process.env.REACT_APP_API_KEY}
        `)

        dispatch({type:'GET_FORECAST',payload:data})
        
        
        
    } catch (error) {
        
    }


}